import React , {Component } from 'react';
import AUX from '../../../hoc/Aux_';
import Grid from '@material-ui/core/Grid';
import {fetchCms} from '../../../api/cms';

class Faq extends Component{

  constructor(props) {
    super(props);
    this.state = {
      cmsData:[]
    }
  }

  componentWillMount() {
    fetchCms("faq")
    .then(response => {
        if (response != null) {
          this.setState({cmsData:response.data});
        }
      })
      .catch(error => {
      });

  }

  renderFaq = (e)=>{
    return (
      <Grid xs={6} style = {{padding:10}}>
            <div className="faq-ans">
                <h3 className="faq-title"><i className="mdi mdi-help-circle"></i>{e.title}</h3>
                <p className="faq-sub-title text-muted pt-2"  style={{textAlign:"justify"}}>{e.description}</p>
            </div>
      </Grid>
    )
  }

    render(){
        return(
            <AUX>
                <section className="section bg-light" id="faq">
                    <div className="container">
                      <Grid container spacing={3}>

                        {this.state.cmsData.map(this.renderFaq)}

                       </Grid>
                    </div>
                </section>
           </AUX>
        );
    }
}

export default Faq;
